import tagInput from './tagInput.vue';

export default tagInput;
